import {combineReducers} from "redux";
import signup from "./signup/reducers";
import viewer from "./viewer/reducers";
import auth from "./auth/reducers";
import settings from "./settings/reducers";

const rootReducer = combineReducers({
    auth: auth,
    signup: signup,
    viewer: viewer,
    settings: settings
});

export default rootReducer
